import PropTypes from "prop-types";
import { createContext, useState, useMemo } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("it");

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "it" ? "en" : "it"));
  };

  const setSpecificLanguage = (lang) => {
    setLanguage(lang);
  };

  const value = useMemo(() => ({
    language,
    toggleLanguage,
    setLanguage: setSpecificLanguage,
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
